import React, { Component } from "react";
import cx from "classnames";
import moment from "moment-timezone";
import { themr } from "analytics-ui/theme/themr";

import Styles from "./DateRangeLabel.module.scss";
import { relativeToLabel } from "utils/date-range";

class DateRangeLabel extends Component {
  static defaultProps = {
    startDateFormat: "M/DD/YY",
    endDateFormat: "M/DD/YY",
    isDarkTheme: false,
    timezone: "US/Arizona",
  };

  render() {
    const {
      theme,
      dateRange,
      timezone,
      isRealTime,
      startDateFormat,
      endDateFormat,
      isDarkTheme,
      dataTest,
    } = this.props;

    return (
      <span
        className={cx(theme['date-range-label'], { [theme['theme-dark']]: isDarkTheme })}
        data-test={dataTest}
      >
        <span className={theme.datetime}>
          {dateRange.type === "relative" ? (
            <span>
              <span className={theme.date}>
                {relativeToLabel(dateRange, false)}
              </span>
              {dateRange.round && " (rounded)"}
            </span>
          ) : (
            (() => {
              const start = moment.utc(dateRange.start).tz(timezone);
              return (
                <span key="custom-start">
                  <span className={theme.date}>
                    {start.format(startDateFormat)}
                  </span>
                  <span className={theme.time}>{start.format("hh:mm A")}</span>
                </span>
              );
            })()
          )}
        </span>
        <span className={theme.divider}> &#8212; </span>
        <span className={theme.datetime}>
          {dateRange.type === "relative" || isRealTime ? (
            <span>
              <span className={theme.date}>Now</span>
            </span>
          ) : (
            (() => {
              const end = moment.utc(dateRange.end).tz(timezone);
              return (
                <span>
                  <span className={theme.date}>
                    {end.format(endDateFormat)}
                  </span>
                  <span className={theme.time}>{end.format("hh:mm A")}</span>
                </span>
              );
            })()
          )}
        </span>
      </span>
    );
  }
}

export default themr(DateRangeLabel, Styles);
